import { render, staticRenderFns } from "./addressList.vue?vue&type=template&id=de9e5f34&"
import script from "./addressList.vue?vue&type=script&lang=js&"
export * from "./addressList.vue?vue&type=script&lang=js&"
import style0 from "./addressList.vue?vue&type=style&index=0&id=de9e5f34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports